import { h, Fragment } from "preact";
import { useContext } from "preact/hooks"

import { Config } from "../../Store";
import { getSeverityInformation, getEffectiveDateText } from "../../utils";
import { IconChevron } from "../Icons";
import Route from "./Route";
import styles from "./styles.scss";

const Alert = props => {
    let { alert, handleClick, label, isOpen } = props;
    let { title, cause, effect, description, url, start_time, end_time } = alert;
    let config = useContext(Config);
    let sectionID = `taw-a${label}`;
    let headerID = `${sectionID}-header`;
    let {icon, alertLabel} = getSeverityInformation(cause, effect);
    let dateText = getEffectiveDateText(start_time, end_time);
    return (
        <div class={styles.accordionItem}>
            <h3 class={styles.accordionHeading}>
                <button
                    id={headerID}
                    onClick={handleClick}
                    aria-expanded={isOpen.toString()}
                    aria-controls={sectionID}
                    >
                        <span class={styles.severityIcon}>{icon}</span>
                        <span class={styles.title}>{title.en}</span>
                        <span class={styles.toggle}><IconChevron /></span>
                    </button>
            </h3>
            <div
                id={sectionID}
                class={styles.accordionBody}
                aria-labelledby={headerID}
                hidden={!isOpen}
            >
                <strong>{alertLabel}</strong> {description.en}
                { config.showAffected &&
                    <div class={styles.affectedRoutes}>
                        {affectedRoutes(alert)}
                    </div>
                }
                {dateText &&
                    <div class={styles.dateText}>{dateText}</div>
                }
            </div>
        </div>
    );
};

const affectedRoutes = alert => {
    let { applies_systemwide, routes_possibly_affected} = alert;
    routes_possibly_affected.sort((a,b) => {
        return a.route_short_name > b.route_short_name ? 1 : -1;
    });
    if (applies_systemwide) {
        return (
            <Fragment>Affects All Routes</Fragment>
        );
    }
    return (
        <Fragment>
            <strong>Affected Routes:</strong> {
                routes_possibly_affected.map((route, index) => {
                    return (
                        <Fragment key={route.route_id}>
                            {index > 0 && <span>, </span>}
                            <Route route={route} />
                        </Fragment>
                    );
                })
            }
        </Fragment>
    );
}

export default Alert;


// WEBPACK FOOTER //
// ./components/Alert/Alert.js